import styles from './Header.module.scss';
import LogoDecatron from '../../assets/icons/logo_decatron.png';
import DownArrow from '../../assets/icons/down_arrow.svg';
import UpArrow from '../../assets/icons/up_arrow.svg';
import DropDown from '../../assets/icons/dropdown.png';
import DotsMenu from '../../assets/icons/dots.png';
import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useMedia from '../../hooks/useMedia';
import HeaderDivider from '../Divider/HeaderDivider';
import { headerContent } from '../../data/header';

export default function Header() {
    const [indexSelected, setIndexSelected] = useState<number>(0);
    const mobile = useMedia('(max-width: 767px)');
    const [mobileMenu, setMobileMenu] = useState(false);
    const navigate = useNavigate();
    const menuRef = useRef<HTMLDivElement>(null);

    const dropStyles: Record<number, string> = {
        2: styles.dropdown_about,
        4: styles.dropdown_social,
        5: styles.dropdown_compliance,
    };

    const handleClick = (
        index: number,
        url: string | undefined,
        externalLink: boolean | undefined
    ) => {
        if (externalLink) {
            window.open(url, '_blank');
        }

        if (!externalLink && url) {
            void navigate(url);
        }

        if (index === indexSelected) {
            setIndexSelected(-1);
        } else {
            setIndexSelected(index);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIndexSelected(-1);
                setMobileMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <HeaderDivider />
            <header className={styles.header_container} ref={menuRef}>
                <div className={styles.logo_icon}>
                    <img
                        src={LogoDecatron}
                        alt="Logo decatron"
                        onClick={() => void navigate('/home')}
                    />

                    {mobile && (
                        <div
                            className={`${styles.mobile_button}`}
                            onClick={() => setMobileMenu(!mobileMenu)}
                        >
                            {mobileMenu ? (
                                <img src={DotsMenu} alt="dots menu" />
                            ) : (
                                <img src={DropDown} alt="dropdown menu" />
                            )}
                        </div>
                    )}
                </div>
                <nav className={`${mobile && !mobileMenu ? styles.hidden : ''}`}>
                    <ul className={`${mobile ? styles.navigation_mobile : styles.navigation}`}>
                        {headerContent.map((item, index) => (
                            <li
                                className={styles.navigation_items}
                                onClick={() => handleClick(index, item?.url, item.externalLink)}
                                key={index}
                            >
                                {item.name?.toUpperCase()}
                                {item.hasIcon && (
                                    <img
                                        src={index === indexSelected ? UpArrow : DownArrow}
                                        alt="drop arrow"
                                    />
                                )}
                                {item.hasIcon && indexSelected === index && (
                                    <ul
                                        className={`${indexSelected && dropStyles[indexSelected]} ${styles.menu_drop}`}
                                    >
                                        {item.contents?.map((content, index) => (
                                            <div className={styles.nav_icon_box} key={index}>
                                                {content.icon && (
                                                    <img src={content?.icon} alt="icone" />
                                                )}
                                                <Link
                                                    to={content.url}
                                                    target={content.hasTarget ? '_blank' : ''}
                                                    rel="noreferrer"
                                                >
                                                    <li>{content.name}</li>
                                                </Link>
                                            </div>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>
            </header>
        </>
    );
}
